<template>
    <div>
        <h1>Carbonsäuren</h1>
        <p>
            Carbonsäuren entstehen durch die Oxidation von
            <router-link to="aldehyde">Aldehyden</router-link>. Auffällig ist
            die <b>Carboxylgruppe</b>, welche aus einer
            <i>Hydroxylgruppe</i> und einer <i>Carbonylgruppe</i> besteht.
        </p>
        <img
            src="@/assets/img/stoffe/carbon/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Carbonsäuren"
            title="Allgemeine Struktur der Carbonsäuren"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>H-COOH</td>
                    <td>Methansäure</td>
                    <td>Ameisensäure</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>CH<sub>3</sub>-COOH</td>
                    <td>Ethansäure</td>
                    <td>Essigsäure</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>2</sub>H<sub>5</sub>-COOH</td>
                    <td>Propansäure</td>
                    <td>Propionsäure</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>3</sub>H<sub>7</sub>-COOH</td>
                    <td>Butanal</td>
                    <td>Buttersäure</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n+1</sub>-COOH</td>
                    <td><em>Alkan</em>-säure</td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Oxidation eines
                <router-link to="aldehyde">Aldehyds</router-link> => Carbonsäure
            </li>
            <li>
                Reaktion mit einem
                <router-link to="alkohole">Alkohol</router-link> =>
                <router-link to="ester">Ester</router-link>
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading title="Beispiel einer Stukturformel"></chapter-heading>
        <img
            src="@/assets/img/stoffe/carbon/hexansaeure.png"
            alt="Beispielhafte Strukturformel: Hexansäure"
            title="Beispielhafte Strukturformel: Hexansäure"
        />

        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>
                            bestehen aus, C-Atomen, H-Atomen und einer
                            Carboxylgruppe
                        </li>
                        <li>
                            besitzen nur Einfachbindungen und eine
                            C=O-Doppelbindung
                        </li>
                        <li>
                            entstehen aus der Oxidation von
                            <router-link to="aldehyden">Aldehyden</router-link>
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n+1</sub>COOH</td>
            </tr>
            <tr>
                <th>Allgemeine Benennung</th>
                <td><em>Alkan</em>säure</td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>Dipol-Dipol-Kräfte</li>
                        <li>Wasserstoffbrücken nur in Lösung</li>
                        <li>
                            gut Wasserlöslich (nimmt mit zunehmender C-Kette ab)
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>Kohlenwasserstoffkette + endständige HO-C=O</td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
